define([], () => {
    return ['$http', 'LocaleService', 'httpSettings', 'configBasler', 'LoggingDataService', 'VisitorIdService',
        ($http, locale, httpSettings, configBasler, LoggingDataService, VisitorIdService) => {
            const flatten = require('flat').flatten;
            const service = {
                logInfo: (event, error, submission) => logInfo(event, error, submission),
                setEnableLogging: (logging) => setEnableLogging(logging),
                b64EncodeUnicode: (str) => b64EncodeUnicode(str),
                removePersonalData: (data) => removePersonalData(data),
                send: (data) => send(data),
            };

            let enableLogging = true;

            function setEnableLogging(logging) {
                enableLogging = logging;
            }

            // details: https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
            function b64EncodeUnicode(str) {
                // https://stackoverflow.com/questions/23223718/failed-to-execute-btoa-on-window-the-string-to-be-encoded-contains-characte
                return btoa(unescape(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
                    return String.fromCharCode(parseInt(p1, 16));
                })));
            }

            function logInfo(event, error, submission) {
                if (!Object.values(LoggingDataService.getEventTypes()).includes(event) || !enableLogging) {
                    return;
                }
                return VisitorIdService.getVisitorId().then(visitorId => {
                    return service.send({
                        ...LoggingDataService.createLogObject(event, error, submission),
                        'essential.visitorId': visitorId
                    });
                });
            }

            /** remove or scramble personal data. 'data' is expected to be flattened. */
            function removePersonalData(data) {
                const filterInfo = [
                    /^.*?\.firstName.*$/,
                    /^.*?\.lastName.*$/,
                ];

                const anonymizeInfo = [
                    /^.*?\.emailAddress.*$/,
                    /^.*?\.confirmedEmailAddress.*$/,
                    /^.*?\.cellPhone.*$/,
                ];
                const filteredData = LoggingDataService.omitWithRegex(data, filterInfo);
                // https://stackoverflow.com/questions/23223718/failed-to-execute-btoa-on-window-the-string-to-be-encoded-contains-characte
                const result = LoggingDataService.mapValues(filteredData, anonymizeInfo, (key, value) => btoa(unescape(encodeURIComponent(value))));
                return result;
            }

            function send(data) {
                if (!data || !(configBasler && configBasler.logging && configBasler.logging.url)) {
                    return;
                }
                const payload = removePersonalData(flatten(data));

                const headers = {
                    'Content-Type': 'text/plain; charset=utf-8',
                    'Accept-Language': locale.getCurrentLocale(),
                };
                $http(Object.assign({
                    method: 'POST',
                    url: configBasler.logging.url,
                    data: b64EncodeUnicode(JSON.stringify(payload)),
                    headers: headers,
                    timeout: httpSettings.timeout,
                    withCredentials: true,
                }))
                    // we do not want to react on success or error since it is only a log call
                    .then((_) => undefined, (_) => undefined);
            }

            return service;
        }];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/services/LoggingService.js